import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const ieMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('en-IE').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Savings accounts',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42c71e-7190-4618-b581-38951fbcf547',
                            type: 'advanced',
                            title: 'Deposit accounts',
                            href: `${basePath}/savings-accounts/deposit-accounts/`,
                            description: 'Earn a fixed interest rate, with terms ranging from 3 months up to 5 years',
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '8ec5d1d0-4442-4cad-acce-f8875f8b8277',
                            type: 'advanced',
                            title: 'Demand deposit accounts',
                            href: `${basePath}/savings-accounts/demand-deposit-accounts/`,
                            description: 'Top up and withdraw your savings at your convenience',
                            icon: 'terminationPaymentIcon',
                            iconColor: '#317EA6',
                        },
                        {
                            id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                            type: 'advanced',
                            title: 'All savings accounts',
                            href: `${basePath}/savings-accounts/`,
                            description: 'Compare all the savings accounts we offer',
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                    ],
                    sidebar: [
                        {
                            id: 'cd7cce97-3687-43cf-abf7-17981b39200a',
                            type: 'arrow',
                            title: 'High yield savings accounts',
                            href: `${basePath}/savings-accounts/high-yield-savings-account/`,
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'About us',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42we3g-7190-4619-db81-38951dsf',
                            type: 'text',
                            title: 'Get started',
                            href: `${basePath}/how-to-register/`,
                        },
                        {
                            id: '32dsd1d0-4342-4fad-acce-f8fdvf8b1rd3',
                            type: 'text',
                            title: 'How Raisin Bank works',
                            href: `${basePath}/how-it-works/`,
                        },
                        {
                            id: '76d1f1132-12dd-tb42-e341-5fcc74f14tgd',
                            type: 'text',
                            title: 'Our partner banks',
                            href: `${basePath}/bank/`,
                        },
                        {
                            id: '76d1f65gf-67gf-tb42-e341-5fcc74f1434a',
                            type: 'text',
                            title: 'About Raisin Bank',
                            href: `${basePath}/about-raisin/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Information',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                            type: 'advanced',
                            title: 'Deposit protection',
                            href: `${basePath}/deposit-guarantee/`,
                            description: 'Learn about the Deposit Guarantee Scheme',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7ec22c5392125d5b/Deposit_protection.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '5d4de868-91cd-42cc-9358-08173ba5386f',
                            type: 'advanced',
                            title: 'Tax and revenue',
                            href: `${basePath}/tax/`,
                            description: 'How Raisin Bank savings accounts are taxed',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt9d8d32dc1f3a6166/Banks.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'd63e6408-738b-4d6f-927a-bc2274804d69',
                            type: 'advanced',
                            title: 'Savings guides',
                            href: `${basePath}/savings/`,
                            description: 'Everything you need to know about savings',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt9878b0f3ba0d44ff/Savings_guides.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '1d4de43f-1134-12dd-123d-134d3aa52321d',
                            type: 'advanced',
                            title: 'Banking guides',
                            href: `${basePath}/banking/`,
                            description: 'Clear, practical guides to banking and finance',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt54dedccdfc38141b/Banking_guides.svg',
                            iconColor: '#0E6CC5',
                        },
                    ],
                    sidebar: [
                        {
                            id: '948a7d90-538e-4810-98a5-cb62b90055p4',
                            type: 'arrow',
                            title: 'Savings beyond Ireland',
                            href: `${basePath}/savings/savings-beyond-ireland/`,
                        },
                        {
                            id: '948a7dss-53ds-8asd-w8a5-1wewb90s434d',
                            type: 'arrow',
                            title: 'Interest rates explained',
                            href: `${basePath}/banking/interest-rates/`,
                        },
                        {
                            id: 'f10ea65e-7827-42c9-a681-c0b214aeb11d',
                            type: 'arrow',
                            title: 'Where should I invest money?',
                            href: `${basePath}/savings/where-to-invest-money/`,
                        },
                        {
                            id: '948a7dds-543e-4120-9r15-cb62b9004341',
                            type: 'arrow',
                            title: 'What’s next for interest rates',
                            href: `${basePath}/banking/whats-next-for-interest-rates-in-ireland/`,
                        },
                        {
                            id: '1948a434-233e-4fdf-9dw5-cb62b9fdfdf',
                            type: 'arrow',
                            title: 'Inheritance tax',
                            href: `${basePath}/taxes/inheritance-tax/`,
                        },
                        {
                            id: '88688bb5-71d1-49a5-a794-aecc6ee9c41e',
                            type: 'arrow',
                            title: 'Taxes guides',
                            href: `${basePath}/taxes/`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'Help',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'd41882ea-f390-47ed-b94e-3f7a7eea1a33',
                            type: 'text',
                            title: 'Contact us',
                            href: `${basePath}/contact/`,
                        },
                        {
                            id: 'f7c75a69-3287-483f-912f-d4c2432a0708',
                            type: 'text',
                            title: 'Press',
                            href: `${basePath}/press/`,
                        },
                        {
                            id: 'b16af5c5-2320-4317-80fa-fc2a375eb79c',
                            type: 'text',
                            title: 'FAQ',
                            href: 'https://help.raisin.ie/hc/en-gb/',
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'My Account',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Register',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=ieMenus.js.map